import ko from 'knockout';
import Competention from './competention';

export class CompetentionQualityType {
    id: string;
    name: string;
    
    constructor(qualityType: any) {
        this.id = qualityType.id;
        this.name = qualityType.name;
    }
}

export default class QualityType {
    id: KnockoutObservable<string>;
    name: KnockoutObservable<string>;
    competentions: KnockoutObservableArray<Competention>;

    checked: KnockoutObservable<boolean>;

    constructor(qualityType: any) {
        this.id = ko.observable<string>(qualityType.id);
        this.name = ko.observable<string>(qualityType.name);
        this.checked = ko.observable<boolean>(qualityType.checked);

        const competentions = qualityType.competentions.map((c: any) => new Competention(c));
        this.competentions = ko.observableArray<Competention>(competentions);
    }
}